export default __webpack_public_path__ + "static/facial-recognition-5f73cae20fba4622a9ad14d6ed9479f6.jpeg";